import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  constructor(private authService: AuthService, private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    const userEmail = this.route.snapshot.queryParamMap.get("email");
    if (!userEmail) {
      this.router.navigateByUrl("/");
      return;
    }
    const storageKey = `msal.${environment.msal.clientId}.request.origin`;
    const returnUrl = sessionStorage.getItem(storageKey);
    if (returnUrl && returnUrl.includes("reset-password")) {
      sessionStorage.removeItem("returnUrl");
      sessionStorage.removeItem(storageKey);
      if (this.authService.isLoggedIn()) {
        this.router.navigateByUrl("/logoff");
      }
      else {
        this.router.navigateByUrl("/login");
      }
    } else {
      this.authService.logout().subscribe(() => {
        this.authService.resetPassword(userEmail);
      });
    }
  }

}
